module.exports = __webpack_public_path__ + "media/images/emblems/Hasle_bei_Burgdorf-coat_of_arms-575ab129ac9ee9acf2e92574e6d7c132.svg";